module.exports = __webpack_public_path__ + "static/img/1.dc242aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-educacion/1.png
// module id = b8P+
// module chunks = 0